<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>管理员管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['store/seller/add']">添加管理员</el-button>
		</div>
		<el-table :data="list" border>
			<el-table-column prop="id" label="ID"></el-table-column>
			<el-table-column prop="seller_name" label="管理员"></el-table-column>
			<el-table-column label="角色">
				<template slot-scope="scope">
					<el-tag type="primary" size="small" v-if="scope.row.role_id && scope.row.role">{{scope.row.role.name}}</el-tag>
					<el-tag type="success" size="small" v-if="scope.row.is_admin">管理员</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="状态">
				<template slot-scope="scope">
					<el-tag effect="dark" type="success" size="small" v-if="scope.row.status == 1">正常</el-tag>
					<el-tag effect="dark" type="danger" size="small" v-else-if="scope.row.status == 0">锁定</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope" v-if="scope.row.is_admin == 0">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['store/seller/edit']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10">
						<el-button size="mini" type="danger" slot="reference" v-auth="['store/seller/delete']">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			isLoad: false,
			pageSize: 20,
			page: 1,
			total: 0
		}
	},
	created() {
		this.loadList();
	},
	methods: {
		loadList() {
			this.isLoad = !this.isLoad
			this.axios.get('store/seller/index',{params:{
				page:this.page,
				pageSize:this.pageSize
			}}).then(res => {
				this.isLoad = !this.isLoad
				this.list = res.data.list.data
				this.total = res.data.list.total
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		sizeReload(val) {
			this.page = 1
			this.pageSize = val
			this.loadList()
		},
		pageReload(val) {
			this.page = val
			this.loadList()
		},
		edit(id) {
			this.$router.push({
				path: '/User/edit.html',
				query: {
					id: id
				}
			});
		},
		add() {
			this.$router.push({
				path: '/User/edit.html'
			});
		},
		del(id) {
			this.isLoad = !this.isLoad
			this.axios.delete('store/seller/delete', {data: {
				id
			}}).then(() => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '删除成功',
				});
				this.loadList()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		}
	}
}
</script>
<style scoped>
</style>
